import { Template } from "@xapp/ovai-lib";
import { Credentials } from "auth";
import { Handler, Organization } from "generated/graphql";
import { ClientApp, ClientIntent } from "models";
import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { State } from "redux/state";

export type UploadTemplate = "UPLOAD_TEMPLATE";
export const UPLOAD_TEMPLATE: UploadTemplate = "UPLOAD_TEMPLATE";
export type UploadTemplateEnd = "UPLOAD_TEMPLATE_END";
export const UPLOAD_TEMPLATE_END: UploadTemplateEnd = "UPLOAD_TEMPLATE_END";

export interface UploadTemplateAction extends Action {
    payload: {
        credentials: Credentials;
        organization: Organization;
        template: Template;
        selectOnSuccess?: boolean;
    };
    type: UploadTemplate;
}

export function uploadTemplate(
    template: Template,
    selectOnSuccess?: boolean
): ThunkAction<void, State, undefined, UploadTemplateAction> {
    return (dispatch: Dispatch<UploadTemplateAction>, getState) => {
        const credentials = getState().auth.credentials;
        const organization = getState().org.currentOrg;

        dispatch(uploadTemplateWithCredentials(credentials, template, organization, selectOnSuccess));
    };
}

function uploadTemplateWithCredentials(
    credentials: Credentials,
    template: Template,
    organization: Organization,
    selectOnSuccess: boolean
): UploadTemplateAction {
    return {
        payload: {
            credentials,
            organization,
            selectOnSuccess,
            template
        },
        type: UPLOAD_TEMPLATE
    };
}

export interface UploadTemplateEndAction extends Action {
    payload: {
        app?: ClientApp;
        intents?: (ClientIntent | Handler)[];
        error?: Error;
    };
    type: UploadTemplateEnd;
}

export function uploadTemplateEnd(
    error: Error,
    app?: ClientApp,
    intents?: (ClientIntent | Handler)[]
): UploadTemplateEndAction {
    return {
        payload: {
            app,
            error,
            intents
        },
        type: UPLOAD_TEMPLATE_END
    };
}
